import { QuantitySelectorUpdateEvent } from '@theme/events';

export function validPackTotal(quantity, plants, choices) {
  if (!Array.isArray(choices)) return false;
  if (!Number.isSafeInteger(quantity) || quantity <= 0 || !Number.isSafeInteger(plants) || plants <= 0) return false;
  const packs = [...new Set(choices)];
  if (!packs.length || packs.length > 2 || packs.some((n) => !Number.isSafeInteger(n) || n <= 0)) return false;
  if (quantity % plants !== 0) return false;
  const trays = quantity / plants;
  const first = Math.min(...packs);
  const last = Math.max(...packs);
  for (let count = 0; count < first && count * last <= trays; count++) {
    if ((trays - count * last) % first === 0) return true;
  }
  return false;
}

class OppaCartPack extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const select = this.querySelector('select');
    if (!select) return;
    const plants = Number(this.dataset.plants);
    const current = Number(this.dataset.quantity);
    let choices = [];
    try { const parsed = JSON.parse(this.dataset.choices || '[]'); choices = Array.isArray(parsed) ? parsed : []; } catch {}
    const stock = this.dataset.stock === '' ? Infinity : Number(this.dataset.stock);
    const max = this.dataset.maximum === '' ? Infinity : Number(this.dataset.maximum);
    const minimum = Number(this.dataset.minimum || 1);
    const increment = Number(this.dataset.increment || 1);
    const valid = validPackTotal(current, plants, choices) && current >= minimum && current % increment === 0 && current <= Math.min(stock, max);
    this.dataset.oppaPackInvalid = String(!valid || this.dataset.review === 'true' || this.dataset.priceUnit !== 'planta' || this.dataset.legacy === 'true');
    const warning = this.querySelector('[data-pack-warning]');
    if (warning) warning.hidden = this.dataset.oppaPackInvalid !== 'true';
    if (!plants || !choices.length || this.dataset.review === 'true' || this.dataset.priceUnit !== 'planta' || this.dataset.legacy === 'true') {
      select.disabled = true;
      return;
    }
    const limit = Math.min(Math.floor(stock / plants), Math.floor(max / plants), Math.max(current / plants, Math.max(...choices)) + 30);
    select.replaceChildren();
    if (!valid) select.add(new Option(this.dataset.invalidLabel, String(current), true, true));
    for (let trays = Math.max(Math.ceil(minimum / plants), Math.min(...choices)); trays <= limit; trays++) {
      const quantity = trays * plants;
      if (!validPackTotal(quantity, plants, choices) || quantity % increment !== 0) continue;
      const option = new Option(`${trays} ${this.dataset.trayLabel}`, String(quantity));
      option.selected = quantity === current;
      select.add(option);
    }
    if (valid && !Array.from(select.options).some((o) => Number(o.value) === current)) {
      select.add(new Option(`${current / plants} ${this.dataset.trayLabel}`, String(current), true, true));
    }
    select.addEventListener('change', () => {
      this.dispatchEvent(new QuantitySelectorUpdateEvent(Number(select.value), Number(this.dataset.line)));
    });
  }
}

if (!customElements.get('oppa-cart-pack')) customElements.define('oppa-cart-pack', OppaCartPack);

function invalidCart() {
  return document.querySelector('[data-oppa-pack-invalid="true"]');
}
document.addEventListener('click', (event) => {
  if (!invalidCart() || !(event.target instanceof Element)) return;
  if (!event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  invalidCart().querySelector('[data-pack-warning]')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
}, true);
document.addEventListener('submit', (event) => {
  if (!invalidCart() || !(event.target instanceof HTMLFormElement)) return;
  if (!event.target.action.includes('/cart')) return;
  const button = event.submitter;
  if (button && button.getAttribute('name') !== 'checkout') return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);
